import { render, staticRenderFns } from "./AdminUI.vue?vue&type=template&id=feae88f8"
import script from "./AdminUI.vue?vue&type=script&lang=js"
export * from "./AdminUI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports